<template>
  <div
    class="clockWidget notranslate"
    :data-size="item.detail.clock.size"
    :style="{textAlign: item.detail.clock.align}">
    <span class="hour">{{hour}}</span>
    <span class="colon">:</span>
    <span class="minute">{{minute}}</span>
    <span v-if="ampm" class="ampm">{{ampm}}</span>
  </div>
</template>

<script>
import moment from 'moment/moment'

export default {
  name: 'Clock',
  props: [
    'item'
  ],
  mounted () {
    setInterval(() => {
      this.updateTime()
    }, 1000)
  },
  data () {
    return {
      hour: '00',
      minute: '00',
      ampm: null
    }
  },
  methods: {
    updateTime () {
      const hour = this.item.detail.clock.hour24 ? 'HH' : 'hh'
      const minute = 'mm'
      this.hour = moment().format(hour)
      this.minute = moment().format(minute)
      this.ampm = this.item.detail.clock.ampm ? moment().format('A') : null
    }
  }
}
</script>
